export const footer = {
  right: [
    {
      link: "https://www.highsnobiety.com/imprint/",
      label: "Imprint",
    },
    {
      link: "https://www.highsnobiety.com/privacy/",
      label: "Privacy",
    },
    {
      link: "https://www.highsnobiety.com/terms-conditions/",
      label: "Store Terms",
    },
    {
      link: "https://www.highsnobiety.com/terms/",
      label: "Terms",
    },
    {
      link: "/terms",
      label: "NFT Terms",
    },
  ],
  left: {
    label: "Title Media GmbH 2022 ©",
  },
};
